require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).ChevronDown = e.ChevronDown || {}, e.ChevronDown.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function l(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var n = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, n.get ? n : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var a = l(e),
      i = n(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function f(e, r) {
    if (null == e) return {};

    var t,
        n,
        l = function (e, r) {
      if (null == e) return {};
      var t,
          n,
          l = {},
          a = Object.keys(e);

      for (n = 0; n < a.length; n++) {
        t = a[n], r.indexOf(t) >= 0 || (l[t] = e[t]);
      }

      return l;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (n = 0; n < a.length; n++) {
        t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (l[t] = e[t]);
      }
    }

    return l;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        n = e.className,
        l = e.size,
        i = void 0 === l ? 16 : l,
        y = e.title,
        v = e["aria-label"],
        g = e["aria-labelledby"],
        m = e.fill,
        h = e.role,
        O = void 0 === h ? "img" : h,
        j = f(e, d),
        w = t.css(s || (s = c(["\n    color: ", ";\n  "])), m),
        C = t.css(b || (b = c(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, r, t) {
      var n,
          l,
          a = t["aria-label"],
          i = t["aria-labelledby"],
          u = t.title;

      switch (e) {
        case "img":
          return a || i || u ? (o(n = {}, "aria-labelledby", i), o(n, "aria-label", a), o(n, "title", u), n) : {
            "aria-label": (l = r, "".concat(l.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(O, "ChevronDown", (o(r = {
      title: y
    }, "aria-label", v), o(r, "aria-labelledby", g), r));

    return a.createElement("svg", u({
      className: t.cx(o({}, w, null != m), C, n),
      height: "number" == typeof i ? i : p[i],
      width: "number" == typeof i ? i : p[i],
      role: O
    }, x, j, {
      viewBox: "0 0 16 16"
    }), a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.63604 5.36396C1.24551 5.75449 1.24551 6.38765 1.63604 6.77817L6.58579 11.7279L7.29289 12.435C7.68342 12.8256 8.31658 12.8256 8.70711 12.435L9.41421 11.7279L14.364 6.77817C14.7545 6.38765 14.7545 5.75449 14.364 5.36396L13.6569 4.65685C13.2663 4.26633 12.6332 4.26633 12.2426 4.65685L8 8.89949L3.75736 4.65685C3.36684 4.26633 2.73367 4.26633 2.34315 4.65685L1.63604 5.36396Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "ChevronDown", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});